var router = require('pjax').Router;
var index = require('./index.js');
var form = require('./form.js');

router.get('notification/:any', form);
router.get('notification', index);